import * as React from "react"
import { Appearance, Linking, TouchableOpacity, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { Actionsheet, ActionsheetProps } from "../actionsheet/actionsheet"
import { Icon, useDisclose, View } from "native-base"
import { FC, PropsWithChildren, useCallback, useEffect } from "react"
import { LazyRender } from "../lazy-render/lazy-render"
import { Text } from "../text/text"
import { JalaIcon } from "../jala-icon/jala-icon"
import { color } from "../../theme"
import { translate } from "../../i18n"
import _ from "lodash"

export interface CycleProFeatureProps extends PropsWithChildren<any> {
  allow?: boolean,
  isOpen?: boolean,
  onOpen?: () => void,
  onClose?: () => void,

  onPress?: () => void,
  onPressIn?: () => void,
  onPressOut?: () => void,

  actionsheetProps?: ActionsheetProps,

  colorScheme?: "light" | "dark",
  actionSheetColorScheme?: "light" | "dark"
}

const ACTIONSHEET: ViewStyle = {
  minHeight: 132,
  height: undefined
}

const ActionsheetComponent = ({ colorScheme = Appearance.getColorScheme() }) => {
  const onPress = useCallback(() => Linking.openURL('https://jala.tech/pro'), [])

  return (<View py="16px" px="16px">
    <Text mb="8px">
      {translate('cycleProFeature.title').toLowerCase().split('pro').map((t, i, a) => (<Text key={`${i}`} preset="display3" colorScheme={colorScheme}>
        <Text text={t} transformText={_.startCase} preset="display3" colorScheme={colorScheme} />
        {i < (a.length - 1) && <>
          {" "}
          <Icon as={JalaIcon} name="premium-1" size="20px" color={color.palette.orange500} />
          {" "}
          <Text text="Pro" preset="display3" colorScheme={colorScheme} />
        </>}
        {" "}
      </Text>))}
    </Text>
    <Text>
      <Text tx="cycleProFeature.description" preset="body2" colorScheme={colorScheme} />
      {" "}
      <Text
        tx="cycleProFeature.more"
        preset="title4"
        onPress={onPress}
        colorScheme={colorScheme}
        color={color.primary}
      />
    </Text>
  </View>);
}

/**
 * Describe your component here
 */
export const CycleProFeature: FC<CycleProFeatureProps> = observer(function CycleProFeature(props) {
  const {
    allow,
    isDisabled = false,
    isOpen: isOpenProp,
    onOpen: onOpenProp, onClose: onCloseProp, onPress, onPressIn, onPressOut,
    actionsheetProps,
    colorScheme = Appearance.getColorScheme(),
    actionSheetColorScheme = colorScheme,
    clearable,
    children
  } = props

  const { isOpen, onOpen, onClose: onCloseDisclose } = useDisclose()

  useEffect(() => {
    if (isOpenProp) onOpen()
    else if (isOpenProp === false) onCloseDisclose()
  }, [isOpenProp, onCloseDisclose, onOpen])

  useEffect(() => {
    if (isOpen) onOpenProp && onOpenProp()
  }, [isOpen, onOpenProp])

  const onClose: () => void = useCallback(() => {
    onCloseProp && onCloseProp()
    onCloseDisclose()
  }, [onCloseDisclose, onCloseProp])

  return (
    <>
      {allow && children || <>
        <TouchableOpacity
          onPress={onPress || onOpen}
          onPressIn={onPressIn}
          onPressOut={onPressOut}
          disabled={isDisabled}
        >
          {children}
        </TouchableOpacity>
        <Actionsheet
          colorScheme={actionSheetColorScheme}
          isOpen={isOpen}
          onClose={onClose}
          clearable={clearable}
          actionsheetStyle={ACTIONSHEET}
          {...actionsheetProps}
        >
          <LazyRender>
            <ActionsheetComponent
              colorScheme={colorScheme}
            />
          </LazyRender>
        </Actionsheet>
      </>}
    </>
  )
})
